import React from 'react';
import HoverTooltip from '../../../../../../Components/Common/components/HoverTooltip';

/**
 * "Free style" pill shown wherever a model's composition mode matters
 * (editor header, models table). Purple to stay distinct from the green
 * Promoted / orange unpromoted-changes chips.
 */
export const FreestyleBadge = ({ id }: { id?: string }) => (
  <HoverTooltip
    text="Free style — submodel restrictions are off; components can be mixed and duplicated."
    position="bottom"
    useFixed
  >
    <div
      id={id}
      className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-semibold tw-bg-tone-accent-tint tw-text-tone-accent-ink"
    >
      Free style
    </div>
  </HoverTooltip>
);

export default FreestyleBadge;
